/**
 * Signup.tsx
 * 
 * A dedicated signup page that redirects to Pricing with the waitlist form in focus
 * Follows mobile-first design principles and supports offline capabilities
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Footer } from '@/components/layout/Footer';

/**
 * Signup page - redirects to the pricing page with waitlist signup section in focus
 * This ensures all links to /signup work correctly while maintaining a single source of truth
 */
export default function Signup() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to pricing page with hash for the signup section
    const redirectTimer = setTimeout(() => {
      navigate('/pricing#plus-signup-section', { replace: true });
    }, 300); // Small delay for smooth transition

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Sign Up for Meduler Plus | Premium Medication Management</title>
        <meta name="description" content="Join the Meduler Plus waitlist for premium medication management features, including shareable schedules, priority support, and advanced reminders." />
        <link rel="canonical" href="/pricing" />
      </Helmet>

      <div className="flex-1 flex items-center justify-center p-4">
        <div className="flex flex-col items-center justify-center" role="status" aria-live="polite">
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-t-purple-600 border-r-transparent border-b-purple-600 border-l-transparent mb-3"></div>
          <p className="text-sm text-gray-600 dark:text-gray-300">Redirecting to Meduler Plus signup...</p>
          <span className="sr-only">Loading</span>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
